import { render, staticRenderFns } from "./PhoneVerificationModal.vue?vue&type=template&id=59096138&scoped=true&"
import script from "./PhoneVerificationModal.vue?vue&type=script&lang=js&"
export * from "./PhoneVerificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59096138",
  null
  
)

export default component.exports